var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachmentPin = function SvgAttachmentPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#currentColor",
    d: "m10.253 4.818 8.132 8.131a4 4 0 0 1 0 5.657 4 4 0 0 1-5.657 0L3.889 9.767a2.5 2.5 0 0 1 3.536-3.535l7.424 7.424a1.003 1.003 0 0 1 0 1.415 1.003 1.003 0 0 1-1.414 0L6.718 8.353l-1.061 1.06 6.717 6.718a2.5 2.5 0 0 0 3.536-3.535L8.485 5.17a4 4 0 0 0-5.657 0 4 4 0 0 0 0 5.657l8.84 8.839a5.497 5.497 0 0 0 7.777 0 5.497 5.497 0 0 0 0-7.778l-8.131-8.132z"
  })));
};
export default SvgAttachmentPin;